var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportGolf24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_golf24x24",
    transform: "translate(-3 -3)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45953",
    d: "M11,13.489a18.549,18.549,0,0,0-3.822.356V3.356A.382.382,0,0,0,6.822,3h0a.382.382,0,0,0-.356.356h0V16.067a.382.382,0,0,0,.356.356h0a.382.382,0,0,0,.356-.356h0v-.356H7.8c1.067,0,1.867.267,1.867.622s-.8.622-1.867.622-1.778-.267-1.867-.533V14.378C4.244,14.644,3,15.444,3,16.244,3,17.756,6.822,19,11,19c4.356,0,8-1.244,8-2.756S15.356,13.489,11,13.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45954",
    d: "M8.644,9.567l6.3-2.218c.266-.089.266-.532,0-.71L8.644,3.8c-.177,0-.355,0-.444.177V9.212A.406.406,0,0,0,8.644,9.567Z",
    transform: "translate(-.571 -.09)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportGolf24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_golf24x24.6eda824162df657f16ab8a3726a39b93.svg";